const NO_DIETARY_PATTERNS = [
  'no dietary',
  'none',
  'n/a',
  'no requirements',
  'no preference',
]

export function hasDietaryRequirements(value) {
  if (!value || typeof value !== 'string') return false
  const lower = value.trim().toLowerCase()
  return lower.length > 0 && !NO_DIETARY_PATTERNS.some(p => lower.startsWith(p))
}

export function formatLastUsed(timestamp) {
  // Scans store ms; rows the week sync wrote before Oct 2026 hold seconds
  const ms = Number(timestamp) < 1e12 ? Number(timestamp) * 1000 : Number(timestamp)
  const date = new Date(ms)
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

const BARCODE_REGEX = /^(NUCO-|WASTELAND-|WHITEROAD-|P24-|THURSDAY-|ARMADA-)[A-Z0-9]{6}-\d{6}$/
const TRANSFERRED_REGEX = /^(NUCO-|WASTELAND-|WHITEROAD-|P24-|THURSDAY-|ARMADA-)[A-Z0-9]{6}-\d{6}-[A-Z0-9]{6}$/
const PARTIAL_REGEX = /^(NUCO-|WASTELAND-|WHITEROAD-|P24-|THURSDAY-|ARMADA-)[A-Z0-9]{6}$/

/**
 * GBS ticket QR codes now carry the allocation reference followed by a dot and
 * a short-lived HS256 JWT:
 *
 *   NUCO-GNAC8V-030052.eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ii4uLiJ9...
 *   \_____ reference ____/\_________________ token _________________/
 *
 * References never contain a dot, so everything before the first one is the
 * reference and everything after it is the token. validateBarcode checks the
 * reference only; the token is verified separately (utils/qrVerify.js, run by
 * the scanner components via services/qrScan.js). A bare reference with no
 * token stays valid, which is what the guest app falls back to when its key is
 * missing or expired.
 */
export function splitScannedCode(code) {
  if (typeof code !== 'string') {
    return { reference: '', token: null }
  }
  const dot = code.indexOf('.')
  if (dot === -1) {
    return { reference: code, token: null }
  }
  return { reference: code.slice(0, dot), token: code.slice(dot + 1) || null }
}

export function validateBarcode(code, allowPartial = false) {
  const { reference } = splitScannedCode(code)

  if (BARCODE_REGEX.test(reference) || TRANSFERRED_REGEX.test(reference)) {
    return { valid: true }
  }
  if (PARTIAL_REGEX.test(reference)) {
    if (allowPartial) {
      return { valid: true }
    }
    return { valid: false, error: 'Wrong QR Code, not event ticket' }
  }
  return { valid: false, error: 'Invalid QR Code Type' }
}
